import { ws } from "../../../utils/common";

export const deleteEventWS = async ({ id_event }) => {
  const res = await ws(
    "DELETE",
    process.env.REACT_APP_ENDPOINT + "event/" + id_event,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const duplicateEventWS = async ({ id_event }) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "event/duplicate/" + id_event,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const terminatedEventWS = async ({ id_event }) => {
  const res = await ws(
    "PATCH",
    process.env.REACT_APP_ENDPOINT + "event/terminated/" + id_event,
    null,
    { terminated: true },
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const postLikeWS = async ({ id_event }) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "event-like/",
    null,
    { id_event },
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const deleteLikeWS = async ({ id_event }) => {
  const res = await ws(
    "DELETE",
    process.env.REACT_APP_ENDPOINT + "event-like/" + id_event,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};
